function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.51,25.37c2-.56,3.25-1.47,3.25-2.5,0-1.72-3.65-3.12-8.13-3.12S8.5,21.15,8.5,22.87c0,1,1.25,1.94,3.25,2.5Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55,11.62c2.83-.74,5.84,1.52,6.74,5a6.67,6.67,0,0,1-1.72,6.16l-2.82.09s5.51-7.88-2.2-11.25",
    style: {
      fill: "#8e6335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,9.28A5.5,5.5,0,0,0,16.93,9a10.94,10.94,0,0,1,2.35-.28,10,10,0,0,1,3,.43c-.4-1.44-2.19-2.5-4.34-2.5a5.1,5.1,0,0,0-3.58,1.25,5.16,5.16,0,0,0-2.45-.63,4.48,4.48,0,0,0-4.64,4.25A3.91,3.91,0,0,0,7.56,13c.75-1.59,2.82-2.75,5.32-2.89h0a5.37,5.37,0,0,0-3.13,1.57c-1.87,1.82-2.23,4.48-.83,5.94a2.86,2.86,0,0,0,1.1.71c-.37-1.42.3-3.42,1.77-5.18a3.93,3.93,0,0,0,.72,4.66,3.3,3.3,0,0,0,1.18.7,5.11,5.11,0,0,1,.45-4.13,2.78,2.78,0,0,0,.68.73A2.47,2.47,0,0,1,15,13.68a2.44,2.44,0,0,1,3.19-1.36,2.5,2.5,0,0,1,1.16,1,3.3,3.3,0,0,0,0-.77,9,9,0,0,1,1.81,1.25C21.41,12,20.1,10.16,18,9.28Z",
    style: {
      fill: "#6daf04"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceLeave);
export default __webpack_public_path__ + "static/media/presence-leave.32ebedd5.svg";
export { ForwardRef as ReactComponent };